import React, {useEffect, useState} from 'react';
import _ from "lodash";
import ImageSidebarItem from "./image-sidebar-item";
import {getSingleImage, searchImages} from "../../common/services/image-data-service";
import {ReactComponent} from "*.svg";
import {ChevronLeftIcon, ChevronRightIcon, ClipboardDocumentIcon} from "@heroicons/react/24/solid";

const ImageSidebarSection = ({
                                 setSelectedImage,
                                 tags = [],
                                 themes = [],
                                 ignoreInitialSelection,
                                 selectedImageIdsList,
                                 refreshImages,
                                 setRefreshImages,
                                 showSelectAll,
                                 handleSelectAllImages,
                                 handleRemoveAllImages,
                             }) => {
    const [searchText, setSearchText] = useState('');
    const [imagesList, setImagesList] = useState([]);
    const [firstImage, setFirstImage] = useState(null);
    const [lastImage, setLastImage] = useState(null);

    const handleClearSearch = () => {
        setSearchText('');
    }

    const handleSearchText = (event) => {
        setSearchText(_.toLower(event.target.value));
    }

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {
                fetchImages(false, false);
            }, 300);

        return () => clearTimeout(timeoutId);
    }, [searchText, tags]);

    useEffect(() => {
        if (refreshImages) {
            fetchImages(false, false);
        }
    }, [refreshImages]);

    const prepareSearchCriteria = async (previous, next) => {
        const searchCriteriaList = [];
        const selectedTags = [...tags];
        const selectedThemes = [...themes];

        const existingImageList = [...imagesList];

        if (!_.isEmpty(existingImageList)) {
            if (previous) {
                const firstImageDetail = await getSingleImage(firstImage.id);
                searchCriteriaList.push({field: 'endBefore', condition: '==', value: firstImageDetail});
            } else if (next) {
                const lastImageDetail = await getSingleImage(lastImage.id);
                searchCriteriaList.push({field: 'startAfter', condition: '==', value: lastImageDetail});
            }
        }

        _.forEach(selectedTags, tagId => {
            searchCriteriaList.push({field: 'tags.' + tagId, condition: '==', value: true});
        });

        _.forEach(selectedThemes, themeId => {
            searchCriteriaList.push({field: 'themes.' + themeId, condition: '==', value: true});
        });

        if (!_.isEmpty(searchText)) {
            searchCriteriaList.push({field: 'displayLabel', condition: '===', value: searchText});
        }

        return searchCriteriaList;
    }

    const fetchImages = async (previous, next) => {
        const searchCriteriaList = await prepareSearchCriteria(previous, next);
        const imagesListResult = await searchImages(searchCriteriaList);

        setImagesList(imagesListResult);

        if (!ignoreInitialSelection) {
            setSelectedImage(imagesListResult[0]);
        }

        setFirstImage(_.first(imagesListResult));
        setLastImage(_.last(imagesListResult));

        if (refreshImages) {
            setRefreshImages(false);
        }
    }

    return (
        <>

            <div className="bg-gray-500 flex justify-center p-4 sticky top-0">
                <button onClick={() => fetchImages(true, false)}
                        className="button-gray-outline w-full mx-1">
                    Previous
                </button>
                {showSelectAll &&
                    <>
                        <button onClick={() => {
                            handleSelectAllImages(imagesList)
                        }}
                                className="button-green-outline w-full py-2 px-2 mx-1">Add All
                        </button>
                        <button onClick={() => {
                            handleRemoveAllImages()
                        }}
                                className="button-red-outline w-full py-2 px-2 mx-1">Remove All
                        </button>
                    </>
                }
                <button onClick={() => fetchImages(false, true)}
                        className="button-gray-outline w-full py-2 mx-1">
                    Next
                </button>
            </div>

            <div className="flex flex-wrap justify-center p-2 mt-2">
                {imagesList?.map((image, index) => (
                    <React.Fragment key={index}>
                        {image?.thumbnail &&
                            <div>
                                <ImageSidebarItem
                                    imageDetail={image}
                                    setSelectedImage={setSelectedImage}
                                    selectedImageIdsList={selectedImageIdsList}/>
                            </div>
                        }
                    </React.Fragment>
                ))}
            </div>

        </>
    )
}

export default ImageSidebarSection
